export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, accent }) {
  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
      {Icon && <Icon className={`h-4 w-4 mb-3 ${accent ? "text-accent" : "text-muted-foreground"}`} />}
      <div className="font-display text-3xl font-bold tracking-tight text-foreground leading-none">{value}</div>
      <div className="text-xs text-muted-foreground mt-1.5">{label}</div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="rounded-xl border border-dashed border-border bg-card/50 p-12 text-center" data-testid="empty-state">
      {Icon && <Icon className="h-8 w-8 text-muted-foreground/50 mx-auto mb-4" />}
      <h3 className="font-display text-lg font-bold text-foreground">{title}</h3>
      {description && <p className="mt-1.5 text-sm text-muted-foreground max-w-sm mx-auto">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

const statusStyles = {
  live: "bg-accent/10 text-accent border-accent/20",
  draft: "bg-muted text-muted-foreground border-border",
  published: "bg-chart-3/10 text-chart-3 border-chart-3/20",
  scheduled: "bg-chart-3/10 text-chart-3 border-chart-3/20",
  completed: "bg-primary/5 text-primary border-primary/15",
  ended: "bg-primary/5 text-primary border-primary/15",
  archived: "bg-muted text-muted-foreground border-border",
};

export function StatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-0.5 rounded-full border capitalize ${statusStyles[status] || statusStyles.draft}`}>
      {status === "live" && <span className="h-1.5 w-1.5 rounded-full bg-accent animate-pulse" />}
      {status}
    </span>
  );
}
